import React from 'react';
import styled from "styled-components";
import { AllOption, AllThirdPartiesOption, SingleOriginFilterState } from './SingleOriginFilterState';
import { observer } from 'mobx-react-lite';

const AllOptionElement = styled.option`
	font-style: italic;
`;

export const OptionsAllOrArray = ({options, allLabel="all", allThirdPartiesLabel}: {options: string[], allLabel?: string, allThirdPartiesLabel?: string}) => (
	<>
		<AllOptionElement key={AllOption} value={AllOption}>{allLabel}</AllOptionElement>
		{
			allThirdPartiesLabel ?
				<AllOptionElement key={AllThirdPartiesOption} value={AllThirdPartiesOption}>{allThirdPartiesLabel}</AllOptionElement> :
				null
		}
		{
			options.map( option => (
				<option key={option} value={option}>{option}</option>
			))
		}
	</>);

const FilterRowContainer = styled.div`
	display: flex;
	flex-direction: row;
	margin-top: 2px;
	margin-bottom: 2px;
	justify-content: start;
	padding: 4px;
	background-color: rgba(128,128,128,0.1);
`;

const FilterSelectElement = styled.select`
`

const FilterLabel = styled.label`
	flex-direction: row;
	justify-content: start;
	padding-left: 0.25rem;
	padding-right: 0.25rem;
`

const RegisteredDomainFilterSelectedElement = styled(FilterSelectElement)`
	max-width: 25vw; /* calc(min(4rem, 15vw)); */
`
const DomainFilterSelectedElement = styled(FilterSelectElement)`
	max-width: 25vw; /* calc(min(5rem, 20vw)); */
`
const URLFilterSelectedElement = styled(FilterSelectElement)`
	max-width: calc(40vw - 5rem); /* calc(min(10rem, 30vw)); */
`


		{/* <button onClick={ () => singleOriginFilterState.setSortBy('chronological') }>🕒</button>
		<button onClick={ () => singleOriginFilterState.setSortBy('alphanumeric') }>🔤</button>
		<button onClick={ () => singleOriginFilterState.setSortDirection('ascending') }>⬇️</button>
		<button onClick={ () => singleOriginFilterState.setSortDirection('descending') }>⬆️</button> */}

export const SingleOriginFilterView = observer( ({singleOriginFilterState, label}: {
	singleOriginFilterState: SingleOriginFilterState;
	label: string;
}) => {
	return (
		<FilterRowContainer>
			<FilterLabel>{label}</FilterLabel>
			<RegisteredDomainFilterSelectedElement
				hidden={ singleOriginFilterState.registeredDomains.length < 1 }
				disabled={ singleOriginFilterState.registeredDomains.length < 2 }
				value={ singleOriginFilterState.registeredDomains.length === 1 ?
					singleOriginFilterState.registeredDomains[0] :
					singleOriginFilterState.registeredDomainSelected
				}
				onChange={ e => singleOriginFilterState.setDomainOrUrlToFilterFor(e.currentTarget.value)}
			>
				<OptionsAllOrArray 
					options={singleOriginFilterState.registeredDomains}
					allLabel='all registered domains'
					allThirdPartiesLabel={ singleOriginFilterState.supportsFilteringByThirdParties ? 'all third parties' : undefined }	
				/>
			</RegisteredDomainFilterSelectedElement>
			<DomainFilterSelectedElement
				hidden={ singleOriginFilterState.filteredDomains.length < 1 }
				disabled={ singleOriginFilterState.filteredDomains.length < 2 }
				value={ singleOriginFilterState.filteredDomains.length === 1 ?
					singleOriginFilterState.filteredDomains[0] :
					singleOriginFilterState.domainSelected
				}
				onChange={ e => singleOriginFilterState.setDomainOrUrlToFilterFor(e.currentTarget.value)}
			>
				<OptionsAllOrArray options={singleOriginFilterState.filteredDomains} allLabel='all domains' />
			</DomainFilterSelectedElement>
			<URLFilterSelectedElement
				hidden={ singleOriginFilterState.filteredUrls.length < 1 }
				disabled={ singleOriginFilterState.filteredUrls.length < 2 }
				value={ singleOriginFilterState.filteredUrls.length === 1 ?
					singleOriginFilterState.filteredUrls[0] :
					singleOriginFilterState.urlSelected
				}
				onChange={ e => singleOriginFilterState.setDomainOrUrlToFilterFor(e.currentTarget.value)}
			>
				<OptionsAllOrArray options={singleOriginFilterState.filteredUrls} allLabel='all URLs' />
			</URLFilterSelectedElement>
		</FilterRowContainer>
	)
});